import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "../features/cart/cartSlice";
import LoginSlice from "../features/Login/LoginSlice";
import productSlice from "../features/products/productSlice";
import userSlice from "../features/User/userSlice";
import wishlistSlice from "../features/wishlist/wishlistSlice";
import addressSlice from "../features/address/addressSlice";
import orderSlice from "./../features/orders/orderSlice";
import merchantSlice from "../features/merchant/merchantSlice";
import walletSlice from "../features/wallet/walletSlice";
import bankslice from "../features/bank/bankslice";
const store = configureStore({
  reducer: {
    product: productSlice,
    cart: cartSlice,
    Login: LoginSlice,
    wishlist: wishlistSlice,
    user: userSlice,
    address: addressSlice,
    orders: orderSlice,
    merchants: merchantSlice,
    wallet: walletSlice,
    bank: bankslice,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
